import img1 from "../../../resources/images/prizes/경영혁신/NICE평가정보_기업평가 우수기업 인증(2018).png";
import img2 from "../../../resources/images/prizes/경영혁신/근무혁신우수기업선정서_1.jpg";
import img3 from "../../../resources/images/prizes/경영혁신/경제포커스_중소기업 경영대상(2019).png";
import img4 from "../../../resources/images/prizes/경영혁신/가족친화인증서(2025~2028)_1.jpg";
import img5 from "../../../resources/images/prizes/경영혁신/서울지방고용노동청_일생활 균형캠페인 참여(2021).png";
import img6 from "../../../resources/images/prizes/경영혁신/인적자원개발우수기관인증서_1.jpg";
import img7 from "../../../resources/images/prizes/경영혁신/국제e비즈니스학회_혁신경영인상.png";
import img8 from "../../../resources/images/prizes/경영혁신/관세법인에이원 AEO인증서(23.6.1_28.5.31).png";


export const prizesManagement = [
  {
    presenter: "고용노동부",
    content: "근무혁신 우수기업 선정",
    year: 2023,
    image: img2,
  },
  {
    presenter: "고용노동부",
    content: "일터혁신 CEO 클럽회원 위촉",
    year: 2020,
    image: img3,
  },
  {
    presenter: "국제e비즈니스학회",
    content: "혁신경영인상",
    year: 2020,
    image: img7,
  },
  {
    presenter: "성평등가족부",
    content: "가족친화기업 인증",
    year: 2025,
    image: img4,
  },
  {
    presenter: "관세청",
    content: "수출입안전관리 우수업체(AEO) 인증",
    year: 2023,
    image: img8,
  },  
  {
    presenter: "서울지방고용노동청",
    content: "일·생활 균형 캠페인 참여",
    year: 2021,
    image: img5,
  },
  {
    presenter: "한국산업인력공단",
    content: "인적자원개발 우수기관 인증",
    year: 2021,
    image: img6,
  },
  {
    presenter: "NICE평가정보",
    content: "기술평가 우수기업 인증",
    year: 2018,
    image: img1,
  },
];
